import registerReduxModal from 'components/common/hoc/registerReduxModal'
import { TIRE_DETAILS_PROMOTION_MODAL } from 'constant'
import TirePromotionModal from './TirePromotionModal'

export default registerReduxModal({
  name: TIRE_DETAILS_PROMOTION_MODAL
})(TirePromotionModal)

